// import React, { useState, useEffect, useRef, useCallback } from "react";
// import css from "./order.module.css";
// import { v4 as uuidv4 } from "uuid";
// import Swal from "sweetalert2";
// import withUserData from "../HOK/withUserData";
// import { createOrderWithSequence } from "./createOrderWithSequence";
// import logoForSlidef from "../../svg/logoForSlidef.svg";
// import arrowImp from "../../img/arrowDownPick.png";

// import axios from "axios";
// import ProductInOrder from "./productInOrder";
// import { useCartCalculations } from "./useCartCalculations";

// import {
//   getDocs,
//   getDoc,
//   doc,
//   setDoc,
//   collection,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../firebase";

// const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

// async function npGetCitiesSimple(apiKey, query) {
//   if (!apiKey || !query?.trim()) return [];

//   const body = {
//     apiKey,
//     modelName: "Address",
//     calledMethod: "getCities",
//     methodProperties: { FindByString: query },
//   };

//   const res = await fetch(NP_API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body),
//   });

//   const json = await res.json();
//   return Array.isArray(json?.data) ? json.data : [];
// }

// async function npGetWarehousesSimple(apiKey, cityRef, query = "") {
//   if (!apiKey || !cityRef) return [];

//   const body = {
//     apiKey,
//     modelName: "AddressGeneral",
//     calledMethod: "getWarehouses",
//     methodProperties: {
//       CityRef: cityRef,
//       FindByString: query?.trim() || "",
//       Page: "1",
//       Limit: "200",
//     },
//   };

//   const res = await fetch(NP_API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body),
//   });

//   const json = await res.json();
//   return Array.isArray(json?.data) ? json.data : [];
// }

// const Order = ({ setLogin, user, discountInHok }) => {
//   const uidRef = useRef(uuidv4());
//   const uid = uidRef.current;

//   const cityDebounceRef = useRef(null);
//   const deptDebounceRef = useRef(null);
//   const cityBoxRef = useRef(null);
//   const deptBoxRef = useRef(null);

//   const [currentUs, setCurrentUs] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [name, setName] = useState("");
//   const [surName, setSurName] = useState("");
//   const [phone, setPhone] = useState("");

//   const [nameOtr, setNameOtr] = useState("");
//   const [surNameOtr, setSurNameOtr] = useState("");
//   const [phoneOtr, setPhoneOtr] = useState("");

//   const [isNewBuyer, setIsNewBuyer] = useState(true);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [whoCust, setWhoCust] = useState(true);
//   const [choisDostavka] = useState(true);

//   const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
//   const [selectedCountry, setSelectedCountry] = useState("1");
//   const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1");

//   const [cityName, setCityName] = useState("");
//   const [cities, setCities] = useState([]);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [ulVisible, setUlVisible] = useState(false);

//   const [departments, setDepartments] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [departmentQuery, setDepartmentQuery] = useState("");
//   const [deptVisible, setDeptVisible] = useState(false);

//   const [cartProducts, setCartProducts] = useState([]);
//   const [countProductForCart, setCountProductForCart] = useState(0);
//   const [promoApplied, setPromoApplied] = useState(false);

//   const {
//     totalPrice,
//     newFinValue,
//     promoCode,
//     setPromoCode,
//     applyPromoCode,
//     applyElefant,
//   } = useCartCalculations({
//     cartProducts,
//     discountInHok,
//     currentUser: currentUs,
//   });

//   useEffect(() => {
//     const fetchNovaPoshtaKey = async () => {
//       try {
//         const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
//         if (snap.exists()) setNovaPoshtaKey(snap.data().key || "");
//       } catch (e) {
//         console.error("NP key load error:", e);
//       }
//     };

//     fetchNovaPoshtaKey();
//   }, []);

//   useEffect(() => {
//     const fetchCurrentUser = async () => {
//       if (!user?.uid) return;
//       const snap = await getDoc(doc(db, "users", user.uid));
//       if (snap.exists()) setCurrentUs(snap.data());
//     };

//     fetchCurrentUser();
//   }, [user]);

//   useEffect(() => {
//     if (!currentUs) return;

//     if (currentUs.displayName) {
//       const parts = String(currentUs.displayName || "")
//         .trim()
//         .split(/\s+/);
//       setName(parts[0] || "");
//       setSurName(parts.slice(1).join(" ") || "");
//       setPhone(currentUs.phone || "");
//     }

//     if (currentUs?.deliveryCity?.Ref) {
//       setSelectedCity(currentUs.deliveryCity);
//       setCityName(currentUs.deliveryCity?.Description || "");
//       setSelectedDepartment(currentUs.deliveryDepartment || "");
//       setDepartmentQuery(currentUs.deliveryDepartment || "");
//       setSelectedCountry("1");
//       setSelectedDeliveryMethod("1");
//     } else {
//       setSelectedCity(null);
//       setCityName("");
//       setSelectedDepartment("");
//       setDepartmentQuery("");
//       setSelectedCountry("1");
//       setSelectedDeliveryMethod("1");
//     }
//   }, [currentUs]);

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
//         setUlVisible(false);
//       }
//       if (deptBoxRef.current && !deptBoxRef.current.contains(event.target)) {
//         setDeptVisible(false);
//       }
//     };

//     document.addEventListener("mousedown", handleOutsideClick);
//     return () => {
//       document.removeEventListener("mousedown", handleOutsideClick);
//     };
//   }, []);

//   useEffect(() => {
//     if (deptDebounceRef.current) {
//       clearTimeout(deptDebounceRef.current);
//     }

//     if (
//       !novaPoshtaKey ||
//       !selectedCity?.Ref ||
//       selectedDeliveryMethod !== "1"
//     ) {
//       setDepartments([]);
//       return;
//     }

//     deptDebounceRef.current = setTimeout(async () => {
//       try {
//         const list = await npGetWarehousesSimple(
//           novaPoshtaKey,
//           selectedCity.Ref,
//           departmentQuery,
//         );
//         setDepartments(list || []);
//       } catch (e) {
//         console.error("NP warehouses load error:", e);
//         setDepartments([]);
//       }
//     }, 250);

//     return () => {
//       if (deptDebounceRef.current) {
//         clearTimeout(deptDebounceRef.current);
//       }
//     };
//   }, [
//     novaPoshtaKey,
//     selectedCity?.Ref,
//     selectedDeliveryMethod,
//     departmentQuery,
//   ]);

//   const handleCityInputChange = useCallback(
//     (e) => {
//       const val = e.target.value;

//       setCityName(val);
//       setUlVisible(true);
//       setSelectedCity(null);
//       setSelectedDepartment("");
//       setDepartmentQuery("");
//       setDepartments([]);
//       setDeptVisible(false);

//       if (cityDebounceRef.current) {
//         clearTimeout(cityDebounceRef.current);
//       }

//       cityDebounceRef.current = setTimeout(async () => {
//         try {
//           if (!novaPoshtaKey || !val.trim()) {
//             setCities([]);
//             return;
//           }

//           const list = await npGetCitiesSimple(novaPoshtaKey, val);
//           setCities(list || []);
//         } catch (err) {
//           console.error("NP cities load error:", err);
//           setCities([]);
//         }
//       }, 250);
//     },
//     [novaPoshtaKey],
//   );

//   useEffect(() => {
//     return () => {
//       if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);
//       if (deptDebounceRef.current) clearTimeout(deptDebounceRef.current);
//     };
//   }, []);

//   const handleCityClick = useCallback((city) => {
//     setSelectedCity(city || null);
//     setCityName(city?.Description || "");
//     setUlVisible(false);
//     setSelectedDepartment("");
//     setDepartmentQuery("");
//     setDepartments([]);
//     setDeptVisible(false);
//   }, []);

//   const handleDepartmentInputChange = useCallback((e) => {
//     const val = e.target.value;
//     setDepartmentQuery(val);
//     setSelectedDepartment("");
//     setDeptVisible(true);
//   }, []);

//   const handleDepartmentClick = useCallback((dept) => {
//     const value = dept?.Description || "";
//     setSelectedDepartment(value);
//     setDepartmentQuery(value);
//     setDeptVisible(false);
//   }, []);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsRef = collection(db, "product");
//       const productsSnapshot = await getDocs(productsRef);
//       const productsList = productsSnapshot.docs.map((d) => ({
//         id: d.id,
//         ...d.data(),
//       }));

//       const bundlesSnapshot = await getDocs(collection(db, "bundles"));
//       const bundles = bundlesSnapshot.docs.map((d) => ({
//         id: d.id,
//         ...d.data(),
//       }));

//       const actionsSnapshot = await getDocs(collection(db, "actions"));
//       const actions = actionsSnapshot.docs.map((d) => ({
//         id: d.id,
//         ...d.data(),
//       }));

//       const salesSnapshot = await getDocs(collection(db, "sales"));
//       const sales = salesSnapshot.docs.map((d) => ({
//         id: d.id,
//         ...d.data(),
//       }));

//       const now = new Date();
//       const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]");

//       const withFlags = cartLocal
//         .map((ci) => {
//           const product = productsList.find((p) => p.id === ci.uid);
//           if (!product) return null;

//           let actionDiscount = null;
//           const matchedAction = actions.find((a) => {
//             const start = a.startDate ? new Date(a.startDate) : null;
//             const end = a.endDate ? new Date(a.endDate) : null;
//             if (end && now > end) return false;
//             if (start && now < start) return false;

//             const matchProduct = a.appliesTo?.products?.includes(product.id);
//             const productSeries = Array.isArray(product.seria)
//               ? product.seria
//               : typeof product.seria === "string" && product.seria !== ""
//                 ? [product.seria]
//                 : [];
//             const matchSeries = productSeries.some((ser) =>
//               a.appliesTo?.series?.includes(ser),
//             );

//             const productAuthors = Array.isArray(product.textAutor)
//               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
//               : typeof product.textAutor === "string" &&
//                   product.textAutor !== ""
//                 ? [product.textAutor.split(" ")[0].trim()]
//                 : [];
//             const actionAuthors = Array.isArray(a.appliesTo?.authors)
//               ? a.appliesTo.authors.map((x) => (x || "").split(" ")[0].trim())
//               : [];
//             const matchAuthor = productAuthors.some((x) =>
//               actionAuthors.includes(x),
//             );

//             return matchProduct || matchSeries || matchAuthor;
//           });

//           if (matchedAction) actionDiscount = matchedAction.discountPercent;

//           let saleDiscount = null;
//           const matchedSale = sales.find((s) => {
//             const start = s.startDate ? new Date(s.startDate) : null;
//             const end = s.endDate ? new Date(s.endDate) : null;
//             if (end && now > end) return false;
//             if (start && now < start) return false;

//             const applies = s.appliesTo || {};
//             const matchProduct =
//               Array.isArray(applies.products) &&
//               applies.products.includes(product.id);

//             const productSeries =
//               Array.isArray(product.seria) && product.seria.length
//                 ? product.seria
//                 : typeof product.seria === "string" && product.seria !== ""
//                   ? [product.seria]
//                   : Array.isArray(product.series) && product.series.length
//                     ? product.series
//                     : typeof product.series === "string" &&
//                         product.series !== ""
//                       ? [product.series]
//                       : [];

//             const matchSeries =
//               Array.isArray(applies.series) &&
//               productSeries.some((ser) => applies.series.includes(ser));

//             const productAuthors = Array.isArray(product.textAutor)
//               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
//               : typeof product.textAutor === "string" &&
//                   product.textAutor !== ""
//                 ? [product.textAutor.split(" ")[0].trim()]
//                 : [];
//             const saleAuthors = Array.isArray(applies.authors)
//               ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
//               : [];
//             const matchAuthor = productAuthors.some((x) =>
//               saleAuthors.includes(x),
//             );

//             return matchProduct || matchSeries || matchAuthor;
//           });

//           if (matchedSale) {
//             saleDiscount = Number(matchedSale.discountPercent) || 0;
//           }

//           return {
//             ...product,
//             quantity: ci.quantity,
//             actionDiscountPercent: actionDiscount,
//             saleDiscountPercent: saleDiscount,
//             uid: ci.uid,
//           };
//         })
//         .filter(Boolean);

//       bundles.forEach((b) => {
//         const ids = (b.products || []).map((p) => (p.productId || "").trim());
//         const inCart = withFlags.filter((p) =>
//           ids.includes((p.id || "").trim()),
//         );

//         if (inCart.length >= (b.products || []).length) {
//           inCart.forEach((item) => {
//             const matchBundleItem = (b.products || []).find(
//               (p) => (p.productId || "").trim() === (item.id || "").trim(),
//             );
//             if (matchBundleItem?.discount) {
//               item.actionDiscountPercent = matchBundleItem.discount;
//             }
//           });
//         }
//       });

//       setCartProducts(withFlags);
//     };

//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     const total = (cartProducts || []).reduce(
//       (acc, p) => acc + (p.quantity || 0),
//       0,
//     );
//     setCountProductForCart(total);
//   }, [cartProducts]);

//   const handleQuantityChange = (uidItem, quantity) => {
//     const updated = (cartProducts || []).map((p) =>
//       p.uid === uidItem ? { ...p, quantity } : p,
//     );
//     setCartProducts(updated);

//     const cart = JSON.parse(localStorage.getItem("cart") || "[]");
//     const newCart = cart.map((p) =>
//       p.uid === uidItem ? { ...p, quantity } : p,
//     );
//     localStorage.setItem("cart", JSON.stringify(newCart));
//   };

//   const removeProduct = (uidItem) => {
//     const updated = (cartProducts || []).filter((p) => p.uid !== uidItem);
//     setCartProducts(updated);
//     localStorage.setItem("cart", JSON.stringify(updated));
//   };

//   useEffect(() => {
//     const usedPromo = localStorage.getItem("usedPromoCode");
//     if (usedPromo) setPromoApplied(true);
//   }, []);

//   const handleApplyPromoCode = React.useCallback(async () => {
//     if (!cartProducts?.length) {
//       Swal.fire({
//         icon: "info",
//         title: "Зачекайте",
//         text: "Товари ще не завантажені. Спробуйте за кілька секунд.",
//       });
//       return;
//     }

//     const promoCollectionRef = collection(db, "promo");
//     const snapshot = await getDocs(promoCollectionRef);

//     let found = false;

//     for (const docSnap of snapshot.docs) {
//       const pd = { ...docSnap.data(), id: docSnap.id };

//       if (
//         (pd.code || "").trim().toLowerCase() ===
//         (promoCode || "").trim().toLowerCase()
//       ) {
//         found = true;
//         const ok = await applyPromoCode(pd, cartProducts);

//         if (ok) {
//           Swal.fire({
//             icon: "success",
//             title: "Промокод застосовано",
//             text: `Знижка ${pd.discount}% активована!`,
//           });
//           localStorage.setItem("usedPromoCode", promoCode);
//           setPromoApplied(true);
//           setPromoCode("");
//         } else {
//           Swal.fire({
//             icon: "info",
//             title: "Не застосовано",
//             text: "Цей промокод не підходить до вибраних товарів.",
//           });
//         }
//         break;
//       }
//     }

//     if (!found) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Такого промокоду не існує.",
//       });
//     }
//   }, [applyPromoCode, promoCode, cartProducts, setPromoCode]);

//   const handleApplyelefant = async () => {
//     if (!currentUs || !currentUs.elefant || parseInt(currentUs.elefant) === 0) {
//       Swal.fire({
//         icon: "info",
//         title: "Увага",
//         text: "У вас немає доступних слонів для списання.",
//       });
//       return;
//     }

//     const elephantsUsed = await applyElefant(async (uidUpdate) => {
//       const userDocRef = doc(db, "users", uidUpdate);
//       await setDoc(userDocRef, { elefant: "0" }, { merge: true });
//       setCurrentUs((p) => ({ ...(p || {}), elefant: "0" }));
//     });

//     if (elephantsUsed === false) {
//       Swal.fire({
//         icon: "info",
//         title: "Увага",
//         text: "У вас немає доступних слонів для списання.",
//       });
//     } else {
//       Swal.fire({
//         icon: "success",
//         title: "Слони застосовані!",
//         text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
//       });
//     }
//   };

//   const validateForm = () => {
//     if (
//       !(name || "").trim() ||
//       !(surName || "").trim() ||
//       !(phone || "").trim()
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Заповніть: Ім'я, Прізвище, Телефон.",
//       });
//       return false;
//     }

//     if (
//       !selectedOption &&
//       (!(nameOtr || "").trim() ||
//         !(surNameOtr || "").trim() ||
//         !(phoneOtr || "").trim())
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Заповніть дані отримувача.",
//       });
//       return false;
//     }

//     if (!(cityName || "").trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Введіть місто доставки.",
//       });
//       return false;
//     }

//     if (
//       selectedDeliveryMethod === "1" &&
//       !(selectedDepartment || departmentQuery || "").trim()
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Виберіть відділення Нової пошти.",
//       });
//       return false;
//     }

//     return true;
//   };

//   const payParam = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       setLoading(true);

//       const json = JSON.stringify(cartProducts || []);
//       const us = user ? user.uid : "";
//       const finalDepartment = (
//         selectedDepartment ||
//         departmentQuery ||
//         ""
//       ).trim();

//       const orderPayload = {
//         uid,
//         choice: json,
//         totalPrice,
//         finishPrice: newFinValue,
//         phone,
//         name,
//         surName,
//         discount: discountInHok,
//         nameOtr,
//         surNameOtr,
//         phoneOtr,
//         isNewBuyer,
//         cityName,
//         selectedDepartment: finalDepartment,
//         pay: "card",
//         paymentStatus: "false",
//         user: us,
//         status: "Очікує підтвердження",
//         createdAt: serverTimestamp(),
//       };

//       const createdOrderMeta = await createOrderWithSequence(uid, orderPayload);
//       const payload = {
//         id: uid,
//         amount: totalPrice * 100,
//         ccy: 980,
//         merchantPaymInfo: {
//           reference: "84d0070ee4e44667b31371d8f8813947",
//           destination: "Оплата товарів час майстрів",
//           comment: "Оплата товарів час майстрів",
//           customerEmails: [],
//           basketOrder: (cartProducts || []).map((p) => ({
//             name: p.bookName,
//             qty: p.quantity,
//             sum: p.price * 100,
//             icon: p.imageList?.[0],
//             unit: "шт.",
//             code: p.ISBN,
//           })),
//         },
//         webHookUrl: "https://chas-maistriv.com.ua/api/mono/webhook",
//         paymentType: "debit",
//         saveCardData: {
//           saveCard: true,
//           walletId: "69f780d841a0434aa535b08821f4822c",
//         },
//         redirectUrl: "https://chas-maistriv.com.ua/",
//         initiationKind: "merchant",
//         tds: true,
//         newProduct: orderPayload,
//       };

//       const resp = await axios.post(
//         "https://chas-maistriv.com.ua/api/mono/create-payment",
//         payload,
//         { headers: { "Content-Type": "application/json" } },
//       );

//       if (resp?.data && resp?.statusText === "OK") {
//         localStorage.removeItem("cart");
//         window.location.href = resp.data.pageUrl;
//       } else {
//         throw new Error("Помилка створення платежу");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Не вдалося створити оплату. Спробуйте пізніше.",
//       });
//       setLoading(false);
//     }
//   };

//   const handleNewBuyerClick = () => setIsNewBuyer(true);
//   const handleAlwaysBuyerClick = () => setIsNewBuyer(false);

//   const handleOptionClick = (opt) => {
//     if (selectedOption === opt) {
//       setSelectedOption("");
//       setWhoCust(true);
//     } else {
//       setSelectedOption(opt);
//       setWhoCust(false);
//     }
//   };

//   return (
//     <>
//       <div className={css.blueHeaderOrder}>
//         <div className={css.blueHeaderOrderEnter}>
//           <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
//         </div>
//       </div>

//       <div className={css.wrapCenterOrder}>
//         <div className={css.wrapCenterOrderSmall}>
//           <div className={css.firstBlockWrap}>
//             {!currentUs && (
//               <div className={css.newUserOrNoWrap}>
//                 <div
//                   className={`${css.newAlwaysBayer} ${
//                     isNewBuyer ? css.newBayer : ""
//                   }`}
//                   onClick={handleNewBuyerClick}
//                 >
//                   Я новий покупець
//                 </div>
//                 <div
//                   className={`${css.newAlwaysBayer} ${
//                     !isNewBuyer ? css.newBayer : ""
//                   }`}
//                   onClick={handleAlwaysBuyerClick}
//                 >
//                   Я постійний покупець
//                 </div>
//               </div>
//             )}

//             {!user && (
//               <p className={css.registerToOrder}>
//                 <span
//                   onClick={() => setLogin(true)}
//                   className={css.registerToOrderSpan}
//                 >
//                   ЗАРЕЄСТРУВАТИСЬ
//                 </span>{" "}
//                 для відслідковування замовлення
//               </p>
//             )}

//             <p className={css.labelMi}>Особисті дані</p>
//             <div className={css.wrapUserData}>
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Ім'я"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//               />
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Прізвище"
//                 value={surName}
//                 onChange={(e) => setSurName(e.target.value)}
//               />
//               <input
//                 className={css.inputBig}
//                 type="tel"
//                 placeholder="Телефон"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//                 required
//               />
//             </div>

//             <div className={css.deliveryChoisWrap}>
//               <div
//                 className={css.choisWrap}
//                 onClick={() => handleOptionClick("Доставка")}
//               >
//                 <div className={css.choisWi}>
//                   {selectedOption === "Доставка" && <div className={css.wi} />}
//                 </div>
//                 <p className={css.choisP}>Я отримувач</p>
//               </div>
//             </div>

//             {choisDostavka && (
//               <div className={css.wrapUserData}>
//                 <div className={css.chousBooksSelect}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedCountry}
//                     onChange={(e) => setSelectedCountry(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="1">
//                       Україна
//                     </option>
//                   </select>
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div
//                   className={css.chousBooksSelect}
//                   ref={cityBoxRef}
//                   style={{ position: "relative" }}
//                 >
//                   <input
//                     className={css.inputSmallWrap}
//                     type="text"
//                     value={cityName}
//                     onChange={handleCityInputChange}
//                     placeholder="Місто"
//                     onFocus={() => setUlVisible(true)}
//                   />

//                   {ulVisible && Array.isArray(cities) && cities.length > 0 && (
//                     <ul className={css.ulWrapBigCity}>
//                       {cities.map((city, i) => (
//                         <li
//                           onClick={() => handleCityClick(city)}
//                           key={`${city.Ref || i}-${i}`}
//                           className={css.liInListSitu}
//                         >
//                           {city.SettlementTypeDescription
//                             ? `${city.SettlementTypeDescription}, `
//                             : ""}
//                           {city.Description}
//                           {city.AreaDescription
//                             ? `, ${city.AreaDescription}`
//                             : ""}
//                         </li>
//                       ))}
//                     </ul>
//                   )}

//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div className={css.chousBooksSelectBig}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedDeliveryMethod}
//                     onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="1">
//                       Нова пошта
//                     </option>
//                   </select>
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div
//                   className={css.chousBooksSelectBig}
//                   ref={deptBoxRef}
//                   style={{ position: "relative" }}
//                 >
//                   <input
//                     className={css.customSelectQW}
//                     type="text"
//                     value={departmentQuery}
//                     onChange={handleDepartmentInputChange}
//                     onFocus={() => {
//                       if (selectedCity?.Ref && selectedDeliveryMethod === "1") {
//                         setDeptVisible(true);
//                       }
//                     }}
//                     placeholder={
//                       selectedCity?.Ref
//                         ? "Введіть номер або назву відділення"
//                         : "Спочатку оберіть місто"
//                     }
//                     disabled={
//                       !selectedCity?.Ref || selectedDeliveryMethod !== "1"
//                     }
//                   />

//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />

//                   {deptVisible &&
//                     selectedCity?.Ref &&
//                     selectedDeliveryMethod === "1" && (
//                       <ul
//                         className={css.ulWrapBigCity}
//                         style={{
//                           position: "absolute",
//                           top: "calc(100% + 4px)",
//                           left: 0,
//                           width: "100%",
//                           zIndex: 30,
//                           maxHeight: 260,
//                           overflowY: "auto",
//                           background: "#fff",
//                         }}
//                       >
//                         {Array.isArray(departments) &&
//                         departments.length > 0 ? (
//                           departments.map((d, idx) => (
//                             <li
//                               key={`${d.Ref || idx}`}
//                               onClick={() => handleDepartmentClick(d)}
//                               className={css.liInListSitu}
//                             >
//                               {d?.Description || "Відділення"}
//                             </li>
//                           ))
//                         ) : (
//                           <li className={css.liInListSitu}>
//                             Відділень не знайдено
//                           </li>
//                         )}
//                       </ul>
//                     )}
//                 </div>
//               </div>
//             )}

//             {whoCust && (
//               <>
//                 <p className={css.labelMi}>Контактні дані отримувача</p>
//                 <div className={css.wrapUserData}>
//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Ім'я"
//                     value={nameOtr}
//                     onChange={(e) => setNameOtr(e.target.value)}
//                   />
//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Прізвище"
//                     value={surNameOtr}
//                     onChange={(e) => setSurNameOtr(e.target.value)}
//                   />
//                   <input
//                     className={css.inputBig}
//                     type="tel"
//                     placeholder="Телефон"
//                     value={phoneOtr}
//                     onChange={(e) => setPhoneOtr(e.target.value)}
//                     required
//                   />
//                 </div>
//               </>
//             )}

//             <button
//               type="submit"
//               className={css.orderConfirmation}
//               onClick={payParam}
//             >
//               Оформити замовлення
//             </button>
//           </div>

//           <div className={css.wrapProdForOrder}>
//             {cartProducts?.map((el, i) => (
//               <ProductInOrder
//                 key={el?.uid || i}
//                 el={el}
//                 removeProduct={removeProduct}
//                 handleQuantityChange={handleQuantityChange}
//               />
//             ))}

//             <div className={css.lineWrap} />
//             <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
//             <p className={css.sumOrder}>Знижка: {discountInHok} %</p>

//             <div className={css.discountWrapOrder}>
//               <p className={css.slonuInL}>
//                 Ви можете використати Ваші слони. Загальна кількість слонів{" "}
//                 <strong>{currentUs && currentUs.elefant}</strong>
//               </p>
//               <div className={css.promoButton} onClick={handleApplyelefant}>
//                 Застосувати
//               </div>
//             </div>

//             <div className={css.discountWrapOrder}>
//               <input
//                 className={css.promoInput}
//                 type="text"
//                 placeholder="Промокод"
//                 value={promoCode}
//                 onChange={(e) => setPromoCode(e.target.value)}
//                 disabled={promoApplied}
//               />
//               <div className={css.promoButton} onClick={handleApplyPromoCode}>
//                 Застосувати
//               </div>
//             </div>

//             <p className={css.sum}>Сума: {newFinValue} грн</p>
//           </div>
//         </div>
//       </div>

//       {loading && (
//         <div className={css.spinerWrap}>
//           <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
//         </div>
//       )}
//     </>
//   );
// };

// export default withUserData(Order);
import React, { useState, useEffect, useRef, useCallback } from "react";
import css from "./order.module.css";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import withUserData from "../HOK/withUserData";
import { createOrderWithSequence } from "./createOrderWithSequence";
import logoForSlidef from "../../svg/logoForSlidef.svg";
import arrowImp from "../../img/arrowDownPick.png";

import axios from "axios";
import ProductInOrder from "./productInOrder";
import { useCartCalculations } from "./useCartCalculations";

import {
  getDocs,
  getDoc,
  doc,
  setDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

async function npGetCitiesSimple(apiKey, query) {
  if (!apiKey || !query?.trim()) return [];

  const body = {
    apiKey,
    modelName: "Address",
    calledMethod: "getCities",
    methodProperties: { FindByString: query },
  };

  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

async function npGetWarehousesSimple(apiKey, cityRef, query = "") {
  if (!apiKey || !cityRef) return [];

  const body = {
    apiKey,
    modelName: "AddressGeneral",
    calledMethod: "getWarehouses",
    methodProperties: {
      CityRef: cityRef,
      FindByString: query?.trim() || "",
      Page: "1",
      Limit: "200",
    },
  };

  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

function getEffectiveUnitPrice(item) {
  const basePrice = Number(item?.price || 0);
  const hasPriceSale =
    item?.priceSale !== undefined &&
    item?.priceSale !== null &&
    item?.priceSale !== "";
  const isSale = !!item?.saleDiscountPercent;
  const isAction = !!item?.actionDiscountPercent;

  if (hasPriceSale) return Number(item.priceSale) || 0;
  if (isSale) {
    return Math.round(
      basePrice - (basePrice * Number(item.saleDiscountPercent || 0)) / 100,
    );
  }
  if (isAction) {
    return Math.round(
      basePrice - (basePrice * Number(item.actionDiscountPercent || 0)) / 100,
    );
  }

  return basePrice;
}

function buildBasketOrder(cartProducts) {
  return (cartProducts || []).map((item) => ({
    name: item?.bookName || item?.name || "Товар",
    qty: Number(item?.quantity || 0),
    sum: Math.max(Math.round(getEffectiveUnitPrice(item) * 100), 0),
    icon: item?.imageList?.[0] || "",
    unit: "шт.",
    code: item?.ISBN || item?.id || item?.uid || "",
  }));
}

const Order = ({ setLogin, user, discountInHok }) => {
  const uidRef = useRef(uuidv4());
  const uid = uidRef.current;

  const cityDebounceRef = useRef(null);
  const deptDebounceRef = useRef(null);
  const cityBoxRef = useRef(null);
  const deptBoxRef = useRef(null);
  const [showElefantInput, setShowElefantInput] = useState(false);
  const [elefantAmount, setElefantAmount] = useState("");
  const [currentUs, setCurrentUs] = useState(null);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [phone, setPhone] = useState("");

  const [nameOtr, setNameOtr] = useState("");
  const [surNameOtr, setSurNameOtr] = useState("");
  const [phoneOtr, setPhoneOtr] = useState("");

  const [isNewBuyer, setIsNewBuyer] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [whoCust, setWhoCust] = useState(true);
  const [choisDostavka] = useState(true);

  const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("1");
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1");

  const [cityName, setCityName] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [ulVisible, setUlVisible] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [departmentQuery, setDepartmentQuery] = useState("");
  const [deptVisible, setDeptVisible] = useState(false);

  const [cartProducts, setCartProducts] = useState([]);
  const [promoApplied, setPromoApplied] = useState(false);

  const {
    totalPrice,
    newFinValue,
    visibleDiscount,
    promoCode,
    setPromoCode,
    applyPromoCode,
    applyElefant,
  } = useCartCalculations({
    cartProducts,
    discountInHok,
    currentUser: currentUs,
  });

  useEffect(() => {
    const fetchNovaPoshtaKey = async () => {
      try {
        const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
        if (snap.exists()) {
          setNovaPoshtaKey(snap.data().key || "");
        }
      } catch (error) {
        console.error("NP key load error:", error);
      }
    };

    fetchNovaPoshtaKey();
  }, []);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (!user?.uid) return;

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          setCurrentUs(snap.data());
        }
      } catch (error) {
        console.error("User load error:", error);
      }
    };

    fetchCurrentUser();
  }, [user]);

  useEffect(() => {
    if (!currentUs) return;

    if (currentUs.displayName) {
      const parts = String(currentUs.displayName || "")
        .trim()
        .split(/\s+/);
      setName(parts[0] || "");
      setSurName(parts.slice(1).join(" ") || "");
    }

    if (currentUs.phone) {
      setPhone(currentUs.phone || "");
    }

    if (selectedOption) {
      setNameOtr("");
      setSurNameOtr("");
      setPhoneOtr("");
    }

    if (currentUs?.deliveryCity?.Ref) {
      setSelectedCity(currentUs.deliveryCity);
      setCityName(currentUs.deliveryCity?.Description || "");
      setSelectedDepartment(currentUs.deliveryDepartment || "");
      setDepartmentQuery(currentUs.deliveryDepartment || "");
      setSelectedCountry("1");
      setSelectedDeliveryMethod("1");
    } else {
      setSelectedCity(null);
      setCityName("");
      setSelectedDepartment("");
      setDepartmentQuery("");
      setSelectedCountry("1");
      setSelectedDeliveryMethod("1");
    }
  }, [currentUs, selectedOption]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
        setUlVisible(false);
      }
      if (deptBoxRef.current && !deptBoxRef.current.contains(event.target)) {
        setDeptVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (deptDebounceRef.current) {
      clearTimeout(deptDebounceRef.current);
    }

    if (
      !novaPoshtaKey ||
      !selectedCity?.Ref ||
      selectedDeliveryMethod !== "1"
    ) {
      setDepartments([]);
      return;
    }

    deptDebounceRef.current = setTimeout(async () => {
      try {
        const list = await npGetWarehousesSimple(
          novaPoshtaKey,
          selectedCity.Ref,
          departmentQuery,
        );
        setDepartments(list || []);
      } catch (error) {
        console.error("NP warehouses load error:", error);
        setDepartments([]);
      }
    }, 250);

    return () => {
      if (deptDebounceRef.current) {
        clearTimeout(deptDebounceRef.current);
      }
    };
  }, [
    novaPoshtaKey,
    selectedCity?.Ref,
    selectedDeliveryMethod,
    departmentQuery,
  ]);

  const handleCityInputChange = useCallback(
    (e) => {
      const value = e.target.value;

      setCityName(value);
      setUlVisible(true);
      setSelectedCity(null);
      setSelectedDepartment("");
      setDepartmentQuery("");
      setDepartments([]);
      setDeptVisible(false);

      if (cityDebounceRef.current) {
        clearTimeout(cityDebounceRef.current);
      }

      cityDebounceRef.current = setTimeout(async () => {
        try {
          if (!novaPoshtaKey || !value.trim()) {
            setCities([]);
            return;
          }

          const list = await npGetCitiesSimple(novaPoshtaKey, value);
          setCities(list || []);
        } catch (error) {
          console.error("NP cities load error:", error);
          setCities([]);
        }
      }, 250);
    },
    [novaPoshtaKey],
  );

  useEffect(() => {
    return () => {
      if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);
      if (deptDebounceRef.current) clearTimeout(deptDebounceRef.current);
    };
  }, []);

  const handleCityClick = useCallback((city) => {
    setSelectedCity(city || null);
    setCityName(city?.Description || "");
    setUlVisible(false);
    setSelectedDepartment("");
    setDepartmentQuery("");
    setDepartments([]);
    setDeptVisible(false);
  }, []);

  const handleDepartmentInputChange = useCallback((e) => {
    const value = e.target.value;
    setDepartmentQuery(value);
    setSelectedDepartment("");
    setDeptVisible(true);
  }, []);

  const handleDepartmentClick = useCallback((dept) => {
    const value = dept?.Description || "";
    setSelectedDepartment(value);
    setDepartmentQuery(value);
    setDeptVisible(false);
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsSnapshot = await getDocs(collection(db, "product"));
        const productsList = productsSnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        const bundlesSnapshot = await getDocs(collection(db, "bundles"));
        const bundles = bundlesSnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        const actionsSnapshot = await getDocs(collection(db, "actions"));
        const actions = actionsSnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        const salesSnapshot = await getDocs(collection(db, "sales"));
        const sales = salesSnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        const now = new Date();
        const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]");

        const withFlags = cartLocal
          .map((cartItem) => {
            const product = productsList.find((p) => p.id === cartItem.uid);
            if (!product) return null;

            let actionDiscount = null;
            const matchedAction = actions.find((action) => {
              const start = action.startDate
                ? new Date(action.startDate)
                : null;
              const end = action.endDate ? new Date(action.endDate) : null;
              if (end && now > end) return false;
              if (start && now < start) return false;

              const matchProduct = action.appliesTo?.products?.includes(
                product.id,
              );
              const productSeries = Array.isArray(product.seria)
                ? product.seria
                : typeof product.seria === "string" && product.seria !== ""
                  ? [product.seria]
                  : [];
              const matchSeries = productSeries.some((series) =>
                action.appliesTo?.series?.includes(series),
              );

              const productAuthors = Array.isArray(product.textAutor)
                ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
                : typeof product.textAutor === "string" &&
                    product.textAutor !== ""
                  ? [product.textAutor.split(" ")[0].trim()]
                  : [];
              const actionAuthors = Array.isArray(action.appliesTo?.authors)
                ? action.appliesTo.authors.map((x) =>
                    (x || "").split(" ")[0].trim(),
                  )
                : [];
              const matchAuthor = productAuthors.some((author) =>
                actionAuthors.includes(author),
              );

              return matchProduct || matchSeries || matchAuthor;
            });

            if (matchedAction) {
              actionDiscount = matchedAction.discountPercent;
            }

            let saleDiscount = null;
            const matchedSale = sales.find((sale) => {
              const start = sale.startDate ? new Date(sale.startDate) : null;
              const end = sale.endDate ? new Date(sale.endDate) : null;
              if (end && now > end) return false;
              if (start && now < start) return false;

              const applies = sale.appliesTo || {};
              const matchProduct =
                Array.isArray(applies.products) &&
                applies.products.includes(product.id);

              const productSeries =
                Array.isArray(product.seria) && product.seria.length
                  ? product.seria
                  : typeof product.seria === "string" && product.seria !== ""
                    ? [product.seria]
                    : Array.isArray(product.series) && product.series.length
                      ? product.series
                      : typeof product.series === "string" &&
                          product.series !== ""
                        ? [product.series]
                        : [];

              const matchSeries =
                Array.isArray(applies.series) &&
                productSeries.some((series) => applies.series.includes(series));

              const productAuthors = Array.isArray(product.textAutor)
                ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
                : typeof product.textAutor === "string" &&
                    product.textAutor !== ""
                  ? [product.textAutor.split(" ")[0].trim()]
                  : [];
              const saleAuthors = Array.isArray(applies.authors)
                ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
                : [];
              const matchAuthor = productAuthors.some((author) =>
                saleAuthors.includes(author),
              );

              return matchProduct || matchSeries || matchAuthor;
            });

            if (matchedSale) {
              saleDiscount = Number(matchedSale.discountPercent) || 0;
            }

            return {
              ...product,
              quantity: Number(cartItem.quantity || 0),
              actionDiscountPercent: actionDiscount,
              saleDiscountPercent: saleDiscount,
              uid: cartItem.uid,
            };
          })
          .filter(Boolean);

        bundles.forEach((bundle) => {
          const ids = (bundle.products || []).map((p) =>
            (p.productId || "").trim(),
          );
          const inCart = withFlags.filter((product) =>
            ids.includes((product.id || "").trim()),
          );

          if (inCart.length >= (bundle.products || []).length) {
            inCart.forEach((item) => {
              const matchBundleItem = (bundle.products || []).find(
                (p) => (p.productId || "").trim() === (item.id || "").trim(),
              );
              if (matchBundleItem?.discount) {
                item.actionDiscountPercent = matchBundleItem.discount;
              }
            });
          }
        });

        setCartProducts(withFlags);
      } catch (error) {
        console.error("Cart products load error:", error);
        setCartProducts([]);
      }
    };

    fetchProducts();
  }, []);

  const handleQuantityChange = (uidItem, quantity) => {
    const updated = (cartProducts || []).map((product) =>
      product.uid === uidItem ? { ...product, quantity } : product,
    );
    setCartProducts(updated);

    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const newCart = cart.map((item) =>
      item.uid === uidItem ? { ...item, quantity } : item,
    );
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const removeProduct = (uidItem) => {
    const updatedProducts = (cartProducts || []).filter(
      (product) => product.uid !== uidItem,
    );
    setCartProducts(updatedProducts);

    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const newCart = cart.filter((item) => item.uid !== uidItem);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  useEffect(() => {
    const usedPromo = localStorage.getItem("usedPromoCode");
    if (usedPromo) {
      setPromoApplied(true);
    }
  }, []);

  const handleApplyPromoCode = useCallback(async () => {
    if (!cartProducts?.length) {
      Swal.fire({
        icon: "info",
        title: "Зачекайте",
        text: "Товари ще не завантажені. Спробуйте за кілька секунд.",
      });
      return;
    }

    const code = (promoCode || "").trim();
    if (!code) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "Введіть промокод.",
      });
      return;
    }

    try {
      const snapshot = await getDocs(collection(db, "promo"));
      let found = false;

      for (const docSnap of snapshot.docs) {
        const promoData = { ...docSnap.data(), id: docSnap.id };

        if (
          (promoData.code || "").trim().toLowerCase() === code.toLowerCase()
        ) {
          found = true;
          const ok = await applyPromoCode(promoData, cartProducts);

          if (ok) {
            Swal.fire({
              icon: "success",
              title: "Промокод застосовано",
              text: `Знижка ${promoData.discount}% активована!`,
            });
            localStorage.setItem("usedPromoCode", code);
            setPromoApplied(true);
            setPromoCode("");
          } else {
            Swal.fire({
              icon: "info",
              title: "Не застосовано",
              text: "Цей промокод не підходить до вибраних товарів.",
            });
          }
          break;
        }
      }

      if (!found) {
        Swal.fire({
          icon: "error",
          title: "Помилка",
          text: "Такого промокоду не існує.",
        });
      }
    } catch (error) {
      console.error("Promo apply error:", error);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося застосувати промокод.",
      });
    }
  }, [applyPromoCode, cartProducts, promoCode, setPromoCode]);

  const handleApplyElefant = async () => {
    const available = Number(currentUs?.elefant || 0);
    const requested = Number(elefantAmount || 0);

    if (!currentUs?.uid || available <= 0) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "У вас немає доступних слонів для списання.",
      });
      return;
    }

    if (!requested || requested <= 0) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "Вкажіть кількість слонів для списання.",
      });
      return;
    }

    try {
      const elephantsUsed = await applyElefant(
        requested,
        async (uidUpdate, usedAmount) => {
          const currentAmount = Number(currentUs?.elefant || 0);
          const nextAmount = Math.max(
            currentAmount - Number(usedAmount || 0),
            0,
          );

          const userDocRef = doc(db, "users", uidUpdate);

          await setDoc(
            userDocRef,
            { elefant: String(nextAmount) },
            { merge: true },
          );

          setCurrentUs((prev) => ({
            ...(prev || {}),
            elefant: String(nextAmount),
          }));
        },
      );

      if (elephantsUsed === false) {
        Swal.fire({
          icon: "info",
          title: "Увага",
          text: "Не вдалося застосувати слонів.",
        });
        return;
      }

      setElefantAmount("");
      setShowElefantInput(false);

      Swal.fire({
        icon: "success",
        title: "Слони застосовані!",
        text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
      });
    } catch (error) {
      console.error("Elefant apply error:", error);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося застосувати слонів.",
      });
    }
  };

  const validateForm = () => {
    if (!(cartProducts || []).length) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Кошик порожній.",
      });
      return false;
    }

    if (
      !(name || "").trim() ||
      !(surName || "").trim() ||
      !(phone || "").trim()
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть: Ім'я, Прізвище, Телефон.",
      });
      return false;
    }

    if (
      !selectedOption &&
      (!(nameOtr || "").trim() ||
        !(surNameOtr || "").trim() ||
        !(phoneOtr || "").trim())
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть дані отримувача.",
      });
      return false;
    }

    if (!(cityName || "").trim()) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Введіть місто доставки.",
      });
      return false;
    }

    if (
      selectedDeliveryMethod === "1" &&
      !(selectedDepartment || departmentQuery || "").trim()
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Виберіть відділення Нової пошти.",
      });
      return false;
    }

    return true;
  };

  const payParam = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);

      const cartJson = JSON.stringify(cartProducts || []);
      const userUid = user?.uid || "";
      const finalDepartment = (
        selectedDepartment ||
        departmentQuery ||
        ""
      ).trim();
      const finalAmountMinor = Math.max(
        Math.round(Number(newFinValue || 0) * 100),
        0,
      );
      const basketOrder = buildBasketOrder(cartProducts);

      const orderPayload = {
        uid,
        choice: cartJson,
        totalPrice,
        finishPrice: newFinValue,
        discount: Number(discountInHok || 0),
        cartDiscountPercent: Number(visibleDiscount || 0),
        phone,
        name,
        surName,
        nameOtr: selectedOption ? name : nameOtr,
        surNameOtr: selectedOption ? surName : surNameOtr,
        phoneOtr: selectedOption ? phone : phoneOtr,
        isNewBuyer,
        cityName,
        selectedDepartment: finalDepartment,
        pay: finalAmountMinor > 0 ? "card" : "elefant",
        paymentStatus: finalAmountMinor > 0 ? "false" : "true",
        user: userUid,
        status: "Очікує підтвердження",
        createdAt: serverTimestamp(),
      };

      await createOrderWithSequence(uid, orderPayload);

      if (finalAmountMinor <= 0) {
        localStorage.removeItem("cart");
        localStorage.removeItem("usedPromoCode");
        setLoading(false);

        Swal.fire({
          icon: "success",
          title: "Замовлення оформлено",
          text: "Замовлення створено без додаткової оплати.",
        });
        return;
      }

      const payload = {
        id: uid,
        amount: finalAmountMinor,
        ccy: 980,
        merchantPaymInfo: {
          reference: "84d0070ee4e44667b31371d8f8813947",
          destination: "Оплата товарів час майстрів",
          comment: "Оплата товарів час майстрів",
          customerEmails: [],
          basketOrder,
        },
        webHookUrl: "https://chas-maistriv.com.ua/api/mono/webhook",
        paymentType: "debit",
        saveCardData: {
          saveCard: true,
          walletId: "69f780d841a0434aa535b08821f4822c",
        },
        redirectUrl: "https://chas-maistriv.com.ua/",
        initiationKind: "merchant",
        tds: true,
        newProduct: orderPayload,
      };

      const resp = await axios.post(
        "https://chas-maistriv.com.ua/api/mono/create-payment",
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      if (resp?.data?.pageUrl) {
        localStorage.removeItem("cart");
        localStorage.removeItem("usedPromoCode");
        window.location.href = resp.data.pageUrl;
        return;
      }

      throw new Error("Помилка створення платежу");
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося створити оплату. Спробуйте пізніше.",
      });
      setLoading(false);
    }
  };

  const handleNewBuyerClick = () => setIsNewBuyer(true);
  const handleAlwaysBuyerClick = () => setIsNewBuyer(false);

  const handleOptionClick = (option) => {
    if (selectedOption === option) {
      setSelectedOption("");
      setWhoCust(true);
      return;
    }

    setSelectedOption(option);
    setWhoCust(false);
  };

  return (
    <>
      <div className={css.blueHeaderOrder}>
        <div className={css.blueHeaderOrderEnter}>
          <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
        </div>
      </div>

      <div className={css.wrapCenterOrder}>
        <div className={css.wrapCenterOrderSmall}>
          <div className={css.firstBlockWrap}>
            {!currentUs && (
              <div className={css.newUserOrNoWrap}>
                <div
                  className={`${css.newAlwaysBayer} ${
                    isNewBuyer ? css.newBayer : ""
                  }`}
                  onClick={handleNewBuyerClick}
                >
                  Я новий покупець
                </div>
                <div
                  className={`${css.newAlwaysBayer} ${
                    !isNewBuyer ? css.newBayer : ""
                  }`}
                  onClick={handleAlwaysBuyerClick}
                >
                  Я постійний покупець
                </div>
              </div>
            )}

            {!user && (
              <p className={css.registerToOrder}>
                <span
                  onClick={() => setLogin(true)}
                  className={css.registerToOrderSpan}
                >
                  ЗАРЕЄСТРУВАТИСЬ
                </span>{" "}
                для відслідковування замовлення
              </p>
            )}

            <p className={css.labelMi}>Особисті дані</p>
            <div className={css.wrapUserData}>
              <input
                className={css.inputBig}
                type="text"
                placeholder="Ім'я"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="text"
                placeholder="Прізвище"
                value={surName}
                onChange={(e) => setSurName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="tel"
                placeholder="Телефон"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            <div className={css.deliveryChoisWrap}>
              <div
                className={css.choisWrap}
                onClick={() => handleOptionClick("Доставка")}
              >
                <div className={css.choisWi}>
                  {selectedOption === "Доставка" && <div className={css.wi} />}
                </div>
                <p className={css.choisP}>Я отримувач</p>
              </div>
            </div>

            {choisDostavka && (
              <div className={css.wrapUserData}>
                <div className={css.chousBooksSelect}>
                  <select
                    className={css.customSelect}
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                  >
                    <option className={css.customOpin} value="1">
                      Україна
                    </option>
                  </select>
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                <div
                  className={css.chousBooksSelect}
                  ref={cityBoxRef}
                  style={{ position: "relative" }}
                >
                  <input
                    className={css.inputSmallWrap}
                    type="text"
                    value={cityName}
                    onChange={handleCityInputChange}
                    placeholder="Місто"
                    onFocus={() => setUlVisible(true)}
                  />

                  {ulVisible && Array.isArray(cities) && cities.length > 0 && (
                    <ul className={css.ulWrapBigCity}>
                      {cities.map((city, index) => (
                        <li
                          onClick={() => handleCityClick(city)}
                          key={`${city.Ref || index}-${index}`}
                          className={css.liInListSitu}
                        >
                          {city.SettlementTypeDescription
                            ? `${city.SettlementTypeDescription}, `
                            : ""}
                          {city.Description}
                          {city.AreaDescription
                            ? `, ${city.AreaDescription}`
                            : ""}
                        </li>
                      ))}
                    </ul>
                  )}

                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                <div className={css.chousBooksSelectBig}>
                  <select
                    className={css.customSelect}
                    value={selectedDeliveryMethod}
                    onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
                  >
                    <option className={css.customOpin} value="1">
                      Нова пошта
                    </option>
                  </select>
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                <div
                  className={css.chousBooksSelectBig}
                  ref={deptBoxRef}
                  style={{ position: "relative" }}
                >
                  <input
                    className={css.customSelectQW}
                    type="text"
                    value={departmentQuery}
                    onChange={handleDepartmentInputChange}
                    onFocus={() => {
                      if (selectedCity?.Ref && selectedDeliveryMethod === "1") {
                        setDeptVisible(true);
                      }
                    }}
                    placeholder={
                      selectedCity?.Ref
                        ? "Введіть номер або назву відділення"
                        : "Спочатку оберіть місто"
                    }
                    disabled={
                      !selectedCity?.Ref || selectedDeliveryMethod !== "1"
                    }
                  />

                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />

                  {deptVisible &&
                    selectedCity?.Ref &&
                    selectedDeliveryMethod === "1" && (
                      <ul
                        className={css.ulWrapBigCity}
                        style={{
                          position: "absolute",
                          top: "calc(100% + 4px)",
                          left: 0,
                          width: "100%",
                          zIndex: 30,
                          maxHeight: 260,
                          overflowY: "auto",
                          background: "#fff",
                        }}
                      >
                        {Array.isArray(departments) &&
                        departments.length > 0 ? (
                          departments.map((dept, index) => (
                            <li
                              key={`${dept.Ref || index}`}
                              onClick={() => handleDepartmentClick(dept)}
                              className={css.liInListSitu}
                            >
                              {dept?.Description || "Відділення"}
                            </li>
                          ))
                        ) : (
                          <li className={css.liInListSitu}>
                            Відділень не знайдено
                          </li>
                        )}
                      </ul>
                    )}
                </div>
              </div>
            )}

            {whoCust && (
              <>
                <p className={css.labelMi}>Контактні дані отримувача</p>
                <div className={css.wrapUserData}>
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Ім'я"
                    value={nameOtr}
                    onChange={(e) => setNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Прізвище"
                    value={surNameOtr}
                    onChange={(e) => setSurNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="tel"
                    placeholder="Телефон"
                    value={phoneOtr}
                    onChange={(e) => setPhoneOtr(e.target.value)}
                    required
                  />
                </div>
              </>
            )}

            <button
              type="submit"
              className={css.orderConfirmation}
              onClick={payParam}
            >
              Оформити замовлення
            </button>
          </div>

          <div className={css.wrapProdForOrder}>
            {cartProducts?.map((el, index) => (
              <ProductInOrder
                key={el?.uid || index}
                el={el}
                removeProduct={removeProduct}
                handleQuantityChange={handleQuantityChange}
              />
            ))}

            <div className={css.lineWrap} />
            <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
            <p className={css.sumOrder}>Знижка: {visibleDiscount || 0} %</p>

            <div className={css.discountWrapOrder}>
              <div>
                <p className={css.slonuInL}>
                  Ви можете використати Ваші слони. Загальна кількість слонів{" "}
                  <strong>{currentUs?.elefant || 0}</strong>
                </p>

                {showElefantInput && (
                  <input
                    className={css.promoInput}
                    type="number"
                    min="1"
                    placeholder="Скільки слонів ви бажаєте списати?"
                    value={elefantAmount}
                    onChange={(e) => setElefantAmount(e.target.value)}
                  />
                )}
              </div>

              {!showElefantInput ? (
                <div
                  className={css.promoButton}
                  onClick={() => setShowElefantInput(true)}
                >
                  Застосувати
                </div>
              ) : (
                <div className={css.promoButton} onClick={handleApplyElefant}>
                  Списати
                </div>
              )}
            </div>

            <div className={css.discountWrapOrder}>
              <input
                className={css.promoInput}
                type="text"
                placeholder="Промокод"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                disabled={promoApplied}
              />
              <div className={css.promoButton} onClick={handleApplyPromoCode}>
                Застосувати
              </div>
            </div>

            <p className={css.sum}>Сума: {newFinValue} грн</p>
          </div>
        </div>
      </div>

      {loading && (
        <div className={css.spinerWrap}>
          <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
        </div>
      )}
    </>
  );
};

export default withUserData(Order);
